import React, { useContext, useState } from 'react';
import Context from '../../../../context/context';

const Notes = () =>{

    const {state, dispatch} = useContext(Context);
    const [notes, setNotes] = useState(state.notes);
    const setNotesDispatch = data => dispatch({type:"SET_NOTES", payload: data});

    const handleChange = (event) => {
        setNotes(event.target.value);
        setNotesDispatch(event.target.value);
    };

    return (
        <div>
            <textarea
                className='invitationInput noteInput'
                placeholder="הערות "
                rows={4}
                value={notes}
                onChange={handleChange}
                style={{ direction: 'rtl' , height : '150px' }}
            />
        </div> 
    )
}

export default Notes;